/**
 * Persists a set of strings in a comma-separated, URL-encoded cookie.
 *
 *   const collapsed = new CookieSet("collapsed_providers");
 *   collapsed.add("Mass Save");
 *   collapsed.remove("Mass Save");
 *   collapsed.has("Mass Save");
 *   collapsed.values();
 */

const DEFAULT_MAX_AGE = 60 * 60 * 24 * 365;

export default class CookieSet {
  constructor(name, { maxAge = DEFAULT_MAX_AGE, sameSite = "Lax" } = {}) {
    this.name = name;
    this.maxAge = maxAge;
    this.sameSite = sameSite;
  }

  values() {
    const prefix = `${this.name}=`;
    const row = document.cookie.split("; ").find((r) => r.startsWith(prefix));
    if (!row) return [];
    const raw = decodeURIComponent(row.substring(prefix.length));
    return raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  has(value) {
    return this.values().includes(value);
  }

  add(value) {
    const set = new Set(this.values());
    set.add(value);
    this.write([...set]);
  }

  remove(value) {
    const set = new Set(this.values());
    set.delete(value);
    this.write([...set]);
  }

  write(list) {
    const encoded = encodeURIComponent(list.join(","));
    document.cookie = `${this.name}=${encoded}; max-age=${this.maxAge}; SameSite=${this.sameSite}`;
  }
}
